export type ServiceType = 'Salle' | 'Cuisine';
export type ShiftServiceType = 'midi' | 'soir' | 'midi+soir' | 'none';
// hors_effectif : jour avant l'entrée ou après la sortie du salarié (cf. effectifUtils.ts).
export type ShiftType = 'travail' | 'repos' | 'absence' | 'hors_effectif';

export const ABSENCE_TYPES = [
  "Ecole", "AA", "RN", "JF", "RJF", "AT", "AM", "CM", "SUSPENDU", "RCF", "CP", "HAB/DES", "MISE A DISPO"
] as const;

export interface TimeSlot {
  start: string;
  end: string;
}

export interface Template {
  id: string;
  name: string;
  role: string;
  serviceType: ShiftServiceType;
  slots: TimeSlot[];
  color?: string; // Hex code
}

export interface ShiftSegment {
  type: 'horaire' | 'code';
  start?: string; // HH:MM
  end?: string;   // HH:MM
  label?: string; // REPOS, AA, etc.
  templateId?: string; // Link to original template for coloring
  color?: string; // Color from template (auto-synced)
  colorOverride?: string; // Custom color for this specific segment instance
  hasOverride?: boolean;
  note?: string;
}

export interface Shift {
  date: string; // YYYY-MM-DD
  type: ShiftType;
  serviceType: ShiftServiceType;
  segments: ShiftSegment[];
  isManual?: boolean;
  /** Créneau d'origine d'un jour « hors effectif », rétabli si la période d'effectif s'élargit. */
  previous?: Shift;
}

export interface PlanningRow {
  employeeId: string;
  employeeName: string;
  employeeRole: string; // job_post_title or position
  isExtra: boolean;
  shifts: Record<string, Shift>;
}

export interface ExtraShift {
  id: string;
  planningId?: string;
  label: "Hôtesse LBE" | "Brigad Plage" | "Agent de sécurité" | string;
  date: string;
  start: string;
  end: string;
  count: number;
}

export interface Planning {
  id: string;
  weekStart: string;
  weekEnd: string;
  service: ServiceType;
  status: 'active' | 'archived';
  rows: PlanningRow[];
  extraShifts: ExtraShift[];
  createdAt: number;
  /** Publié = visible des salariés. Posé par le serveur à la lecture (colonne planning_weeks.publie), jamais écrit par le client. */
  publie?: boolean;
}
export const getContrastColor = (hexColor?: string) => {
  if (!hexColor || hexColor === 'transparent') return '#000000';
  const color = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor;
  if (color.length !== 6) return '#000000';

  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.65 ? '#000000' : '#FFFFFF';
};
